export const LanguagesInSydney = [
  {
    heading: "Chinese",
    detail:
      "Chinese translation services may be necessary if you're looking to access the 487,976 demographic in Sydney, to broaden your business' horizons. We translate into Mandarin to English or English to Cantonese, or any other language you need.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Vietnamese",
    detail:
      "Vietnamese is a language spoken by 75,615 residents of Sydney, and by 1 million of the world's Vietnamese-speaking population. Vietnamese translation services make sure your business can translate all documents in that language, as well as certify it, if necessary.",
    link: "/vietnamese-translation.php",
  },
  {
    heading: "Arabic",
    detail:
      "Maybe you're looking for translation in Arabic script or interpretation in spoken Arabic. If you are, you're in the right place. Sydney's Arabic population comprises 194,049 people, and don't you want to make sure your products and services are in their language?",
    link: "/arabic-translation.php",
  },
  {
    heading: "French",
    detail:
      "Aside from being a major language in the world, French is also spoken by about 8,963 people in Sydney. French translation services at Tomedes is composed of translators who can translate from French into Australian English, and vice versa.",
    link: "/french-translation.php",
  },
  {
    heading: "Greek",
    detail:
      "Another popular language in Sydney, Greek is spoken by 76,196 residents in Sydney. Our Greek translators have the know-how of Greek and many of its dialects, making sure that you get the Greek translation services you deserve.",
    link: "/greek-translation.php",
  },
  {
    heading: "Italian",
    detail:
      "If you're looking for Italian translation services in Sydney, never fear, Tomedes is here. Our Italian translators can transform Australian English into Sicilian Italian or any other variant of Italian. Just say the word, and give us a call.",
    link: "/italian-translation.php",
  },
];
